import axios from 'axios'
import { MessageBox } from 'element-ui'

const request = axios.create({
    // headers: {
    //   'Access-Control-Allow-Origin':'*'
    // }
  })
  

/**
 * 修改环境一共要修改如下几点
 * 1.BaseApi.js的request.defaults.baseURL
 * 2.src\router\index.js的const    = "/exp/"
 * 3.vue.config.js的publicPath
 */

// request.defaults.baseURL = 'http://121.41.84.37/j3dps_exp'
request.defaults.baseURL = 'http://121.41.84.37/j3dps'
// request.defaults.baseURL = 'http://localhost:8081/'
  request.interceptors.request.use(config => {
    config.headers['Access-Control-Allow-Origin'] ="*";
    return config;
  })
  request.interceptors.response.use(response => {
    return response
  }, error =>{
    MessageBox.alert("发生了一些意想不到的问题，快去找猜猜解决一下！凌雪交流群：876052779 ")
    return Promise.reject(error);
  })

export default request; 